(function () {
  const section = document.querySelector("[data-product-accordion]");
  if (!section) return;

  const sectionId = section.getAttribute("data-section-id");
  const productUrl = section.getAttribute("data-product-url");

  if (!sectionId || !productUrl) return;

  function initTabs(container) {
    container.querySelectorAll("[data-naehrwerte-tab]").forEach((tab) => {
      tab.addEventListener("click", handleTabClick);
    });
  }

  function handleTabClick(event) {
    const button = event.currentTarget;
    const tabValue = button.getAttribute("data-naehrwerte-tab");
    const tableId = button.getAttribute("data-naehrwerte-target");
    const table = document.querySelector(
      `[data-naehrwerte-table="${tableId}"]`,
    );

    if (!table) return;

    table.querySelectorAll("[data-naehrwerte-tab]").forEach((tab) => {
      const isActive = tab.getAttribute("data-naehrwerte-tab") === tabValue;
      tab.setAttribute("aria-pressed", isActive ? "true" : "false");
      tab.classList.toggle("text-primary", isActive);
      tab.classList.toggle("text-subdued", !isActive);
    });

    table.querySelectorAll("[data-naehrwerte-panel]").forEach((panel) => {
      const isActive = panel.getAttribute("data-naehrwerte-panel") === tabValue;
      panel.classList.toggle("hidden", !isActive);
    });
  }

  function updateNaehrwerte(variantId) {
    const url = `${productUrl}?variant=${variantId}&sections=${sectionId}`;

    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const html = data[sectionId];
        if (!html) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newAccordion = doc.querySelector("[data-naehrwerte-accordion]");
        const currentAccordion = section.querySelector(
          "[data-naehrwerte-accordion]",
        );

        if (!currentAccordion && newAccordion) {
          const accordionContainer = section.querySelector(
            ".flex-1.space-y-4 > div",
          );
          if (accordionContainer) {
            accordionContainer.appendChild(newAccordion);
            initTabs(newAccordion);
          }
          return;
        }

        if (currentAccordion && !newAccordion) {
          currentAccordion.remove();
          return;
        }

        if (!currentAccordion || !newAccordion) return;

        const newContent = newAccordion.querySelector(
          "[data-naehrwerte-content]",
        );
        const currentContent = currentAccordion.querySelector(
          "[data-naehrwerte-content]",
        );

        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
          initTabs(currentAccordion);
        }
      })
      .catch(() => {
        // Silently fail - nutrition table update is non-critical
      });
  }

  document.addEventListener("variant:changed", (event) => {
    if (event.detail && event.detail.variantId) {
      updateNaehrwerte(event.detail.variantId);
    }
  });
})();
